const API_URL = 'https://www.barcodepapel.pt:5017/api/events';

// ðŸš€ CACHE
const cache = new Map();
const imageCache = new Map(); // Cache separado para imagens

function getCached(key, maxAge = 30000) {
  const cached = cache.get(key);
  if (cached && Date.now() - cached.timestamp < maxAge) {
    console.log(` Cache HIT: ${key}`);
    return cached.data;
  }
  return null;
}

function setCache(key, data) {
  cache.set(key, { data, timestamp: Date.now() });
}

function clearCache() {
  cache.clear();
  imageCache.clear();
  console.log('ðŸ—‘ï¸ Cache limpo');
}

class EventService {

  async getEventsOptimized() {
    const cacheKey = 'events_optimized';
    const cached = getCached(cacheKey, 30000); // 30s cache
    if (cached) return cached;

    try {
      console.time('â±ï¸ getEventsOptimized');

      const response = await fetch(`${API_URL}/public/list`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar eventos');
      }

      const data = await response.json();
      setCache(cacheKey, data);

      console.timeEnd('â±ï¸ getEventsOptimized');
      console.log(` ${data.length} eventos carregados (SEM imagens)`);

      return data;
    } catch (error) {
      console.error('Erro ao buscar eventos otimizados:', error);
      throw error;
    }
  }

  async getEventsOptimizedAdmin() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/list`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar eventos');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar eventos (admin optimized):', error);
      throw error;
    };
  }

  async getEventImagesAdmin(eventId) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/${eventId}/images`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        return { images: [], dailyDetails: [] };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar imagens (admin):', error);
      return { images: [], dailyDetails: [] };
    }
  }


  // âš¡ Carregar imagens de um evento especÃ­fico (lazy loading)
  async getEventImages(eventId) {
    const cacheKey = `event_images_${eventId}`;

    // Verifica cache de imagens
    if (imageCache.has(cacheKey)) {
      console.log(` Image Cache HIT: ${eventId}`);
      return imageCache.get(cacheKey);
    }

    try {
      const response = await fetch(`${API_URL}/${eventId}/images`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar imagens');
      }

      const data = await response.json();
      imageCache.set(cacheKey, data);

      return data;
    } catch (error) {
      console.error('Erro ao buscar imagens:', error);
      // Retorna estrutura vazia em caso de erro
      return { images: [], dailyDetails: [] };
    }
  }

  // âš¡ Carregar TimeSlots de um evento especÃ­fico (lazy loading)
  async getEventTimeSlots(eventId) {
    const cacheKey = `event_timeslots_${eventId}`;

    if (imageCache.has(cacheKey)) {
      console.log(` TimeSlots Cache HIT: ${eventId}`);
      return imageCache.get(cacheKey);
    }

    try {
      const response = await fetch(`${API_URL}/${eventId}/timeslots`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        return []; // Sem timeslots
      }

      const data = await response.json();
      imageCache.set(cacheKey, data);

      return data;
    } catch (error) {
      console.error('Erro ao buscar timeslots:', error);
      return [];
    }
  }

  // Método original mantido para compatibilidade
  async getEvents() {
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar eventos');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar eventos:', error);
      throw error;
    }
  }

  async getEvent(id) {
    try {
      const response = await fetch(`${API_URL}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar evento');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar evento:', error);
      throw error;
    }
  }

  // ðŸš€ NOVO - Para AdminDashboard (RÃPIDO)
  async getEventsSummary() {
    const cacheKey = 'events_summary_admin';
    const cached = getCached(cacheKey, 30000);
    if (cached) return cached;

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`${API_URL}/admin/summary`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Erro ao buscar resumo de eventos');

      const data = await response.json();
      setCache(cacheKey, data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar resumo de eventos:', error);
      throw error;
    }
  }

  async getAllEventsAdmin() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/all`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar eventos');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar eventos (admin):', error);
      throw error;
    }
  }

  async getAllEventReservationsAdmin() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/reservations`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar reservas de eventos');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar reservas de eventos (admin):', error);
      throw error;
    }
  }

  async getAdminDashboard() {
    const cacheKey = 'admin_dashboard_full';
    const cached = getCached(cacheKey, 30000); // Cache de 30s
    if (cached) return cached;

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      console.time('â±ï¸ Admin Dashboard API Call');

      const response = await fetch(`${API_URL}/admin/dashboard`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      console.timeEnd('â±ï¸ Admin Dashboard API Call');

      if (!response.ok) throw new Error('Erro ao buscar dashboard');

      const data = await response.json();
      setCache(cacheKey, data);

      console.log(' Dashboard carregado:', {
        eventos: data.events?.length || 0,
        reservations: data.eventReservations?.length || 0,
        tempoAPI: data.metadata?.loadTimeMs + 'ms'
      });

      return data;
    } catch (error) {
      console.error('Erro ao buscar dashboard:', error);
      throw error;
    }
  }

  // âš¡ MÃ‰TODO OTIMIZADO - Obter imagens só quando necessário
  // NOTA: Este método agora é substituÃ­do pelo getEventImages acima

  // âš¡ Carregar detalhes só quando clica num dia
  async getDayDetails(date) {
    const dateStr = date.toISOString().split('T')[0];
    const cacheKey = `day_details_${dateStr}`;
    const cached = getCached(cacheKey, 30000);
    if (cached) return cached;

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`${API_URL}/admin/day-details?date=${date.toISOString()}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Erro ao buscar detalhes do dia');

      const data = await response.json();
      setCache(cacheKey, data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar detalhes do dia:', error);
      throw error;
    }
  }

  // âš¡ EstatÃ­sticas rápidas
  async getQuickStats() {
    const cacheKey = 'quick_stats';
    const cached = getCached(cacheKey, 60000);
    if (cached) return cached;

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`${API_URL}/admin/stats`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Erro ao buscar estatÃ­sticas');

      const data = await response.json();
      setCache(cacheKey, data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar estatÃ­sticas:', error);
      throw error;
    }
  }

  // âš¡ SUPER RÃPIDO: Só dados para calendário
  async getCalendarData(startDate, endDate) {
    const cacheKey = `calendar_${startDate}_${endDate}`;
    const cached = getCached(cacheKey, 60000);
    if (cached) return cached;

    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await fetch(`${API_URL}/admin/calendar-data?${params}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Erro ao buscar dados do calendário');

      const data = await response.json();
      setCache(cacheKey, data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar calendário:', error);
      throw error;
    }
  }

  async createEvent(eventData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao criar evento');
      }

      clearCache();
      return data;
    } catch (error) {
      console.error('Erro ao criar evento:', error);
      throw error;
    }
  }

  async updateEvent(id, eventData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar evento');
      }

      clearCache();
      return data;
    } catch (error) {
      console.error('Erro ao atualizar evento:', error);
      throw error;
    }
  }

  async deleteEvent(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Erro ao eliminar evento');
      }

      const data = await response.json();
      clearCache();
      return data;
    } catch (error) {
      console.error('Erro ao eliminar evento:', error);
      throw error;
    }
  }

  async reserveEvent(eventId, reservationData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/${eventId}/reserve`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reservationData)
      });

      let data;
      try {
        data = await response.json();
      } catch {
        const text = await response.text();
        console.error("âŒ Resposta bruta do servidor:", text);
        throw new Error("Erro ao interpretar resposta do servidor");
      }

      if (!response.ok) {
        console.error("âŒ Erro do servidor:", data);
        throw new Error(data.message || 'Erro ao fazer reserva');
      }

      clearCache();
      return data;
    } catch (error) {
      console.error('âŒ Erro ao fazer reserva:', error);
      throw error;
    }
  }

  async toggleEventStatus(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/${id}/toggle-status`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Erro ao alterar status do evento');
      }

      const data = await response.json();
      clearCache();
      return data;
    } catch (error) {
      console.error('Erro ao alterar status do evento:', error);
      throw error;
    }
  }

  async getMyReservations() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/my-reservations`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar reservas');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar reservas:', error);
      throw error;
    }
  }

  async adminCancelEventReservation(reservationId) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`https://www.barcodepapel.pt:5017/api/admin/cancel-event-reservation/${reservationId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao cancelar reserva de evento');
      }

      // Limpar cache para recarregar dados
      clearCache();

      return await response.json();
    } catch (error) {
      console.error('Erro ao cancelar reserva de evento:', error);
      throw error;
    }
  }

  async adminUpdateEventReservation(reservationId, updateData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`https://www.barcodepapel.pt:5017/api/admin/update-event-reservation/${reservationId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao atualizar reserva de evento');
      }

      // Limpar cache para recarregar dados
      clearCache();

      return await response.json();
    } catch (error) {
      console.error('Erro ao atualizar reserva de evento:', error);
      throw error;
    }
  }

  formatDateForAPI(date) {
    if (!date) return null;

    if (typeof date === 'string') {
      if (date.includes('T')) {
        return date;
      }
      return `${date}T10:00:00.000Z`;
    }

    return date.toISOString();
  }

  prepareEventData(formData) {
    return {
      title: formData.title.trim(),
      description: formData.description.trim(),
      startDate: this.formatDateForAPI(formData.startDate),
      endDate: formData.endDate ? this.formatDateForAPI(formData.endDate) : null,
      eventType: formData.eventType,
      price: parseFloat(formData.price),
      maxReservations: parseInt(formData.maxReservations),
      images: Array.isArray(formData.images) ? formData.images : []
    };
  }

  async convertImageToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async uploadImages(files) {
    try {
      const fileArray = Array.from(files);
      const imagePromises = fileArray.map(file =>
        this.convertImageToBase64(file)
      );
      const images = await Promise.all(imagePromises);
      return images;
    } catch (error) {
      console.error('Erro ao fazer upload de imagens:', error);
      throw error;
    }
  }

  validateEventData(eventData) {
    const errors = [];

    if (!eventData.title || eventData.title.trim() === '') {
      errors.push('TÃ­tulo é obrigatório');
    }

    if (!eventData.description || eventData.description.trim() === '') {
      errors.push('Descrição é obrigatória');
    }

    if (!eventData.startDate) {
      errors.push('Data de inÃ­cio é obrigatória');
    }

    if (eventData.eventType === 'multi' && !eventData.endDate) {
      errors.push('Data de fim é obrigatória para eventos de mÃºltiplos dias');
    }

    if (!eventData.price || parseFloat(eventData.price) < 0) {
      errors.push('Preço inválido');
    }

    if (!eventData.maxReservations || parseInt(eventData.maxReservations) < 1) {
      errors.push('NÃºmero de reservas deve ser maior que zero');
    }

    if (!eventData.images || eventData.images.length === 0) {
      errors.push('Pelo menos uma imagem é obrigatória');
    }

    return {
      valid: errors.length === 0,
      errors: errors
    };
  }

  calculateDuration(startDate, endDate) {
    if (!endDate) return 1;

    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays + 1;
  }

  formatPrice(price) {
    return new Intl.NumberFormat('pt-PT', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  }

  formatDate(date) {
    return new Date(date).toLocaleDateString('pt-PT', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  isEventFull(event) {
    return event.currentReservations >= event.maxReservations;
  }

  isEventPast(startDate) {
    return new Date(startDate) < new Date();
  }

  // ðŸ“… Buscar disponibilidade de TimeSlots por data especÃ­fica
  async getTimeSlotAvailability(eventId, date = null) {
    try {
      const url = date
        ? `${API_URL}/${eventId}/timeslots/availability?date=${date}`
        : `${API_URL}/${eventId}/timeslots/availability`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        return [];
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar disponibilidade:', error);
      return [];
    }
  }
}

export default new EventService();